import type { MapMarkerInterface } from '../../GoogleMap.types';
import {
  GOOGLE_MAPS_DIRECTIONS_BASE_URL,
  MIN_ZOOM,
  MAX_ZOOM,
} from '../../constants';

export const getGoogleMapsDirectionsUrl = (
  location: MapMarkerInterface | undefined,
) => {
  if (!location || !location.address) {
    return undefined;
  }
  const url = new URL(GOOGLE_MAPS_DIRECTIONS_BASE_URL);
  url.searchParams.set('api', '1');
  url.searchParams.set('destination', location.address);
  return url.toString();
};

export const getLinkInfo = (location: MapMarkerInterface) => {
  const link = location?.locationLinkAttributes;

  const isLinkValid =
    link &&
    typeof link === 'object' &&
    'href' in link &&
    typeof link.href === 'string' &&
    link.href;

  const anchorProps = isLinkValid
    ? {
        href: link.href,
        ...('target' in link && typeof link.target === 'string' && link.target
          ? { target: link.target }
          : {}),
        ...('rel' in link && typeof link.rel === 'string' && link.rel
          ? { rel: link.rel }
          : {}),
      }
    : {};

  return {
    isLinkValid: Boolean(isLinkValid),
    anchorProps,
  };
};

export const isValidLocationParam = (loc: number | null | undefined) => {
  if (loc === 0) {
    return true;
  }
  return !!loc;
};

export const isValidZoom = (zoom: number | null | undefined) => {
  return (
    zoom !== undefined && zoom !== null && zoom >= MIN_ZOOM && zoom <= MAX_ZOOM
  );
};
